import React from 'react';
import { Box } from '@mui/material';

const Spice = ({ color = '#2196f3', ...rest }) => <Box sx={{ width: 5, height: 'inherit', background: color }} {...rest} />;

export default Spice;
